import { render, staticRenderFns } from "./navRecursion.html?vue&type=template&id=227646dc&scoped=true&external"
import script from "./NavRecursion.vue?vue&type=script&lang=js"
export * from "./NavRecursion.vue?vue&type=script&lang=js"
import style0 from "./NavRecursion.vue?vue&type=style&index=0&id=227646dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227646dc",
  null
  
)

export default component.exports